export default __webpack_public_path__ + "static/media/Travel_01.86bcc200.png";